import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import React, { forwardRef } from "react";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import { IconSizes } from "atoms/constants/icon-sizes";
import useNotebookActionPermission, {
    NotebookAction,
} from "pages/notebooks/use-notebook-action-permissions";
import NotebookRecord from "models/view-models/notebook-record";

export interface DeleteNotebookMenuItemProps extends ButtonProps {
    onClick: () => void;
    notebook: NotebookRecord;
}

const DeleteNotebookMenuItem = forwardRef<
    HTMLButtonElement,
    DeleteNotebookMenuItemProps
>((props, ref) => {
    const { notebook, onClick, children, ...rest } = props;
    const { t } = useLocalization();
    const { can } = useNotebookActionPermission(notebook);

    return (
        can(NotebookAction.Delete) && (
            <Button
                ref={ref}
                accessibleText={t("deleteItem", {
                    item: t("notebook"),
                })}
                cssClassName={"-icon-left delete-button"}
                onClick={onClick}
                {...rest}>
                <Icon type={Icons.Trashcan} size={IconSizes.Small} />
                {t("deleteItem", {
                    item: t("notebook"),
                })}
            </Button>
        )
    );
});

export default DeleteNotebookMenuItem;
